import React from 'react';
import { MotifCheckbox } from '@ey-xd/motif-react';

export default (props) => {
  let rowsChecked = 0;
  let totalRows = 0;
  let noPublishableRows = true;
  let totalRowsPublishable = 0;
  let rowsCheckedPublishable = 0;

  // Evaluate filtered rows only
  props.api.forEachNodeAfterFilter((rowNode) => {
    if (rowNode.data) {
      totalRows++;
      if (rowNode.data.isTestResultsDataPublished) {
        rowsChecked++;
      }

      if (rowNode.data.isTestResultsServiceScopeEnabled) {
        totalRowsPublishable++;
        noPublishableRows = false;
      }
      if (
        rowNode.data.isTestResultsDataPublished &&
        rowNode.data.isTestResultsServiceScopeEnabled
      ) {
        rowsCheckedPublishable++;
      }
    }
  });

  let headerCheckboxValue = false;
  let indeterminate = false;

  if (rowsChecked === 0) {
    headerCheckboxValue = false;
  } else if (totalRows === rowsChecked) {
    headerCheckboxValue = true;
  } else if (
    totalRowsPublishable === rowsCheckedPublishable &&
    totalRowsPublishable > 0
  ) {
    headerCheckboxValue = true;
  } else {
    headerCheckboxValue = false;
    indeterminate = true;
  }

  return (
    <div className="d-flex align-items-center justify-content-center mt-1">
      <MotifCheckbox
        type="checkbox"
        name="publish-header-checkbox"
        id="ag-publish-header-checkbox"
        checked={headerCheckboxValue}
        data-testid="chkPublishTestResult"
        aria-label="Press Space to toggle row selection"
        tabIndex="-1"
        onClick={() => props.onHeaderCheckboxChange(headerCheckboxValue)}
        indeterminate={indeterminate}
        disabled={noPublishableRows}
      ></MotifCheckbox>
      <div className="customHeaderLabel">{props.displayName}</div>
    </div>
  );
};
